const RATING_KEYS = {
  TWO: 'TWO',
  THREE: 'THREE',
  FOUR: 'FOUR',
  FIVE: 'FIVE',
  SIX: 'SIX',
  SEVEN: 'SEVEN',
  EIGHT: 'EIGHT',
  NINE: 'NINE',
  TEN: 'TEN',
  ELEVEN: 'ELEVEN',
};

export const RATING_VALUES = {
  [RATING_KEYS.TWO]: 2,
  [RATING_KEYS.THREE]: 3,
  [RATING_KEYS.FOUR]: 4,
  [RATING_KEYS.FIVE]: 5,
  [RATING_KEYS.SIX]: 6,
  [RATING_KEYS.SEVEN]: 7,
  [RATING_KEYS.EIGHT]: 8,
  [RATING_KEYS.NINE]: 9,
  [RATING_KEYS.TEN]: 10,
  [RATING_KEYS.ELEVEN]: 11,
};

export const RATING_LABELS = {
  [RATING_KEYS.TWO]: 'ratingLabelTwo',
  [RATING_KEYS.THREE]: 'ratingLabelThree',
  [RATING_KEYS.FOUR]: 'ratingLabelFour',
  [RATING_KEYS.FIVE]: 'ratingLabelFive',
  [RATING_KEYS.SIX]: 'ratingLabelSix',
  [RATING_KEYS.SEVEN]: 'ratingLabelSeven',
  [RATING_KEYS.EIGHT]: 'ratingLabelEight',
  [RATING_KEYS.NINE]: 'ratingLabelNine',
  [RATING_KEYS.TEN]: 'ratingLabelTen',
  [RATING_KEYS.ELEVEN]: 'ratingLabelEleven',
};

export const DEFAULT_RATING_STARS = RATING_VALUES[RATING_KEYS.FIVE];

export const RATING_STAR_OPTIONS = Object.values(RATING_KEYS).map((key) => ({
  value: RATING_VALUES[key],
  label: RATING_LABELS[key],
}));
